import React, { FC } from "react";
import classNames from "classnames";

type Props = {
    seq: number;
}

const NcdcRequestProgress: FC<Props> = ({ seq }) => {
    const ProgressData = [
        { title: '신청서 작성' },
        { title: '연구기간 정의' },
        { title: '연구과제 작성' },
        { title: '연구원 등록' },
        { title: '데이터 신청' }
    ];

    const ProgressLine = (idx: number) => {
        return (
            idx === 0
                ? null
                : <div className={classNames('common-form-progress-line', {'active': seq >= idx})} />
        );
    };

    const ProgressItem: JSX.Element[] = ProgressData.map((pd, idx) => {
       return (
           <div className={'common-form-progress-item'} key={idx}>
               {ProgressLine(idx)}
               <div className={classNames('common-form-progress-btn'
                   , {'active': seq === idx}
                   , {'checked': seq > idx}
                   , {'disable': seq < idx})}>
                   <div className={classNames('common-form-progress-text'
                       , {'active': seq === idx}
                       , {'disable': seq < idx})}>{pd.title}</div>
               </div>
           </div>
       );
    });

    return (
        <div className={'common-form-progress-wrapper'}>
            <div className={'common-form-progress-icon'}>
                {ProgressItem}
                {/*<div className={'common-form-progress-btn active'}>*/}
                {/*    <div className={'common-form-progress-text active'}>신청서 작성</div>*/}
                {/*</div>*/}
                {/*<div className={'common-form-progress-line active'} />*/}
                {/*<div className={'common-form-progress-btn disable'}>*/}
                {/*    <div className={'common-form-progress-text disable'}>연구기간 정의</div>*/}
                {/*</div>*/}
                {/*<div className={'common-form-progress-line'} />*/}
                {/*<div className={'common-form-progress-btn disable'}>*/}
                {/*    <div className={'common-form-progress-text disable'}>연구과제 작성</div>*/}
                {/*</div>*/}
                {/*<div className={'common-form-progress-line'} />*/}
                {/*<div className={'common-form-progress-btn disable'}>*/}
                {/*    <div className={'common-form-progress-text disable'}>연구원 등록</div>*/}
                {/*</div>*/}
                {/*<div className={'common-form-progress-line'} />*/}
                {/*<div className={'common-form-progress-btn disable'}>*/}
                {/*    <div className={'common-form-progress-text disable'}>데이터 신청</div>*/}
                {/*</div>*/}
            </div>
        </div>
    );
}

export default NcdcRequestProgress;
